import { useEffect } from "react";

import { isMac } from "app/UtilitiesAndConstants/UtilityFunctions/osDetection";

export function useShortcut(key: string, callback: () => void) {
    useEffect(() => {
        const handler = (e: KeyboardEvent) => {
            const isCommandOrCtrl = isMac() ? e.metaKey : e.ctrlKey;

            if (isCommandOrCtrl && e.key.toLowerCase() === key) {
                e.preventDefault();
                callback();
            }
        };

        window.addEventListener("keydown", handler);

        return () => window.removeEventListener("keydown", handler);
    }, [key, callback]);
}
